var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1495_9291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5919 8.37426C11.7753 5.3104 16.8397 5.40729 19.9035 8.59067C22.9674 11.7741 22.8705 16.8384 19.6871 19.9023C16.5038 22.9662 11.4394 22.8693 8.3755 19.6859C5.31163 16.5025 5.40852 11.4381 8.5919 8.37426ZM10.5597 13.5778C10.3257 13.6156 10.1449 13.8164 10.1403 14.0618L10.1466 14.1518C10.1845 14.3858 10.3852 14.5665 10.6306 14.5712L13.63 14.6286L13.5727 17.6281L13.579 17.7181C13.6169 17.9521 13.8176 18.1329 14.063 18.1376L14.153 18.1312C14.387 18.0934 14.5678 17.8926 14.5725 17.6472L14.6299 14.6478L17.6293 14.7051L17.7193 14.6988C17.9533 14.6609 18.1341 14.4602 18.1388 14.2148L18.1325 14.1248C18.0946 13.8908 17.8939 13.71 17.6484 13.7053L14.649 13.6479L14.7064 10.6485L14.7 10.5585C14.6622 10.3245 14.4614 10.1437 14.216 10.139L14.126 10.1454C13.892 10.1832 13.7113 10.3839 13.7066 10.6294L13.6492 13.6288L10.6497 13.5714L10.5597 13.5778Z",
    fill: "#0F6CBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1495_9291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 13.8672) rotate(-43.904)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add-circle.68da37a62b4881547e219b828b66a26e.svg";
export { ForwardRef as ReactComponent };